import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var OPEN_DRAWER = 'Navigation/OPEN_DRAWER';
var CLOSE_DRAWER = 'Navigation/CLOSE_DRAWER';
var TOGGLE_DRAWER = 'Navigation/TOGGLE_DRAWER';
var DRAWER_OPENED = 'Navigation/DRAWER_OPENED';
var DRAWER_CLOSED = 'Navigation/DRAWER_CLOSED';
var MARK_DRAWER_ACTIVE = 'Navigation/MARK_DRAWER_ACTIVE';
var MARK_DRAWER_SETTLING = 'Navigation/MARK_DRAWER_SETTLING';
var MARK_DRAWER_IDLE = 'Navigation/MARK_DRAWER_IDLE';

var openDrawer = function openDrawer(payload) {
  return _objectSpread({
    type: OPEN_DRAWER
  }, payload);
};

var closeDrawer = function closeDrawer(payload) {
  return _objectSpread({
    type: CLOSE_DRAWER
  }, payload);
};

var markDrawerActive = function markDrawerActive(payload) {
  return _objectSpread({
    type: MARK_DRAWER_ACTIVE
  }, payload);
};

var markDrawerIdle = function markDrawerIdle(payload) {
  return _objectSpread({
    type: MARK_DRAWER_IDLE
  }, payload);
};

var markDrawerSettling = function markDrawerSettling(payload) {
  return _objectSpread({
    type: MARK_DRAWER_SETTLING
  }, payload);
};

var toggleDrawer = function toggleDrawer(payload) {
  return _objectSpread({
    type: TOGGLE_DRAWER
  }, payload);
};

export default {
  OPEN_DRAWER: OPEN_DRAWER,
  CLOSE_DRAWER: CLOSE_DRAWER,
  TOGGLE_DRAWER: TOGGLE_DRAWER,
  DRAWER_OPENED: DRAWER_OPENED,
  DRAWER_CLOSED: DRAWER_CLOSED,
  MARK_DRAWER_ACTIVE: MARK_DRAWER_ACTIVE,
  MARK_DRAWER_IDLE: MARK_DRAWER_IDLE,
  MARK_DRAWER_SETTLING: MARK_DRAWER_SETTLING,
  openDrawer: openDrawer,
  closeDrawer: closeDrawer,
  toggleDrawer: toggleDrawer,
  markDrawerIdle: markDrawerIdle,
  markDrawerActive: markDrawerActive,
  markDrawerSettling: markDrawerSettling
};